import { createStore } from "vuex";

class Tag {
  static readonly stair = "stair";
  static readonly trill = "trill";
  static readonly chord = "chord";
  static readonly grace = "grace";
  static readonly burst = "burst";
  static readonly bracket = "bracket";
  static readonly jack = "jack";
  static readonly ln = "ln";
  static readonly shield = "shield";
  static readonly invShield = "invShield";
  static readonly inv = "inv";
  static readonly anchor = "anchor";
  static readonly miniJack = "miniJack";
  static readonly chordJack = "chordJack";
  static readonly chordStream = "chordStream";
  static readonly jumpStream = "jumpStream";
  static readonly handStream = "handStream";
  static readonly quadStream = "quadStream";
  static readonly jumpTrill = "jumpTrill";
  static readonly pJumpTrill = "pJumpTrill";
  static readonly splitTrill = "splitTrill";
  static readonly roll = "roll";
  static readonly gallop = "gallop";
}

interface Pattern {
  tags: Array<string>;
  keys: number;
  lines: number;
  data: string;
}
interface PatternMeta {
  title: string;
  body: string;
  complexity: number;
}
interface State {
  patterns: Array<Pattern>;
  patternMetas: { [name: string]: PatternMeta };
}

const rgStore = createStore({
  state: {
    patterns: [
      {
        tags: [Tag.stair],
        keys: 7,
        lines: 2,
        data: ";    o  ;   o   ;  o    ; o     ;  o    ;   o   ;    o  ;",
      },
      {
        tags: [Tag.stair],
        keys: 7,
        lines: 2,
        data: ";o      ; o     ;  o    ;   o   ;    o  ;     o ;      o;",
      },
      {
        tags: [Tag.stair],
        keys: 4,
        lines: 2,
        data: ";  o ;   o;  o ; o  ;o   ; o  ;  o ;",
      },
      {
        tags: [Tag.stair],
        keys: 4,
        lines: 2,
        data: ";  o ;   o;  o ; o  ;  o ;   o;  o ;",
      },
      {
        tags: [Tag.trill],
        keys: 7,
        lines: 2,
        data: "; o  o  ;  o  o ; o  o  ;  o  o ; o  o  ;  o  o ; o  o  ;  o  o ;",
      },
      {
        tags: [Tag.trill],
        keys: 7,
        lines: 2,
        data: "; oo    ;     o ; oo    ;     o ; oo    ;     o ; oo    ;",
      },
      {
        tags: [Tag.trill],
        keys: 4,
        lines: 2,
        data: ";   o;  o ;   o;  o ;   o;  o ;   o;",
      },
      {
        tags: [Tag.trill],
        keys: 4,
        lines: 2,
        data: "; o  ;   o; o  ;   o; o  ;   o; o  ;",
      },
      {
        tags: [Tag.chord],
        keys: 7,
        lines: 2,
        data: ";   ooo ;-      ;  ooooo;-      ; ooo   ;-      ;ooooo  ;",
      },
      {
        tags: [Tag.chord],
        keys: 7,
        lines: 2,
        data: ";o o o  ;-      ; o o o ;-      ;  o o o;-      ;ooooo  ;",
      },
      {
        tags: [Tag.chord],
        keys: 4,
        lines: 2,
        data: ";ooo ;-   ; o o;-   ; oo ;-   ;oooo;",
      },
      {
        tags: [Tag.chord],
        keys: 4,
        lines: 2,
        data: ";o oo;-   ;o o ;-   ; o o;-   ;o o ;",
      },
      {
        tags: [Tag.grace],
        keys: 7,
        lines: 8,
        data: ";-;-;-;-;-;-;-;-;-;    o  ;     o ;      o;-;-;-;-;-;-;-;-;-;-;-;-;  o    ; o     ;o      ;",
      },
      {
        tags: [Tag.grace],
        keys: 7,
        lines: 8,
        data: ";-;-;-;-;-;-;-;-;-;o      ; o     ;   o   ;     o ;  o    ;    o  ;      o;-;-;-;-;-;-;-;-;-;-;-;-;     o  ;   o    ; o      ;",
      },
      {
        tags: [Tag.grace],
        keys: 4,
        lines: 8,
        data: ";-;-;-;-;-;-;-;-;-; o  ;  o ;   o;-;-;-;-;-;-;-;-;-;-;-;-;   o;  o ;o   ; o  ;",
      },
      {
        tags: [Tag.grace],
        keys: 4,
        lines: 8,
        data: ";-;-;-;-;-;-;-;-;-;   o;  o ;-   ;-   ; o  ;-   ;-   ;-   ;o   ;-;-;-;-;-;-;-;-;-;-;-;-;o   ; o  ;  o ;   o;",
      },
      {
        tags: [Tag.burst],
        keys: 7,
        lines: 8,
        data: ";-;-;-;-;-;-;-; oo o  ;   o o ;ooo o o;-------;-;-;-;-;-;-;  o o  ; o o o ;o   o o;",
      },
      {
        tags: [Tag.burst],
        keys: 7,
        lines: 8,
        data: ";-;-;-;   o o ;  o    ;oo  o o;   o o ;ooo o o;-------;-;-;o o o o; o o o ;o o o o;-------;-;-;",
      },
      {
        tags: [Tag.burst],
        keys: 4,
        lines: 8,
        data: ";-;-;-;-;-;-;-;o  o; oo ;o  o;----;-;-;-;-;-;-; oo ;o  o; oo ;",
      },
      {
        tags: [Tag.burst],
        keys: 4,
        lines: 8,
        data: ";-;-;-; o o;  o ;oo  ;  o ;oo o;----;-;-; o o;o o ;oooo;",
      },
      {
        tags: [Tag.bracket],
        keys: 7,
        lines: 2,
        data: ";-------;    R R;     R ;    R R;-;   B B ; G  B  ;G G    ;",
      },
      {
        tags: [Tag.bracket],
        keys: 7,
        lines: 2,
        data: ";o G    ; G G   ;  R R  ;   R G ;  R R G; o     ;  B B  ; G B  o;G G  o ;",
      },
      {
        tags: [Tag.jack],
        keys: 7,
        lines: 2,
        data: ";  G    ;  G    ;  G    ;  G    ;   R   ;   R   ;   R   ;   R   ;",
      },
      {
        tags: [Tag.jack],
        keys: 7,
        lines: 2,
        data: ";R     o;R    o ;R   o  ;R      ;R    o ;R      ;R   o  ;R    o ;R     o;",
      },
      {
        tags: [Tag.jack],
        keys: 4,
        lines: 2,
        data: "; ooo;R   ;R   ;R   ;Roo ;   R;   R;   R;oooR",
      },
      {
        tags: [Tag.jack],
        keys: 4,
        lines: 2,
        data: ";RRoo;RR  ;RR  ;RR  ;RRoo;",
      },
      {
        tags: [Tag.ln],
        keys: 7,
        lines: 2,
        data: ";     o ;    o| ;   o|^ ;  o|^  ; o|^   ;o|^    ;|^     ;^      ;",
      },
      {
        tags: [Tag.ln],
        keys: 7,
        lines: 2,
        data: ";  oo  o;  |^  o;  ^  o|;o   o||;|o  ^||;||o  ^|;||^   ^;|^  o  ;^  o|  ;  o^^oo;",
      },
      {
        tags: [Tag.shield],
        keys: 7,
        lines: 2,
        data: ";      o;    o |;  o | ^;o | ^ o;| ^ o  ;^ o    ;o      ;",
      },
      {
        tags: [Tag.shield],
        keys: 7,
        lines: 2,
        data: "; o o o ; | | | ; ^ ^ ^ ; o o o ;o o o  ;| | |  ;^ ^ ^  ;o o o  ;",
      },
      {
        tags: [Tag.invShield],
        keys: 7,
        lines: 2,
        data: ";    o  ;   oo  ;  oo|  ; oo|^  ; o|^   ; |^    ; ^     ;",
      },
      {
        tags: [Tag.invShield],
        keys: 7,
        lines: 2,
        data: "; o o o ; o o o ; | | | ; ^ ^ ^ ;  o o o;  o o o;  | | |;  ^ ^ ^;",
      },
      {
        tags: [Tag.inv],
        keys: 7,
        lines: 2,
        data: ";|||||^o;||||^o|;|||^o||;||^o|||;|^o|||^;^o|||^o;o|||^o|;",
      },
      {
        tags: [Tag.inv],
        keys: 7,
        lines: 2,
        data: ";^^^^^^^;ooooooo;|||||||;^|^|^||;o^o^o^|;|o^o^o^;||o|o|o;",
      },
      {
        tags: [Tag.anchor],
        keys: 7,
        lines: 2,
        data: ";R      ; o     ;R o    ;   o   ;R   o  ;  o    ;R  o   ;    o  ;R    o ;   o   ;R   o  ;     o ;R     o;",
      },
      {
        tags: [Tag.anchor],
        keys: 7,
        lines: 2,
        data: "; o R   ;  o   o;   R o ;  o o  ; o R   ;o      ; o R   ;  o o  ;   R o ;  o   o; o R o ;o   o  ; o R   ;",
      },
      {
        tags: [Tag.miniJack],
        keys: 7,
        lines: 2,
        data: ";  o   R;     oR;    o  ;   o   ;R o    ;Ro  o  ;   o  R;     oR;    o  ;   o   ;R o    ;Ro   oo;",
      },
      {
        tags: [Tag.miniJack],
        keys: 7,
        lines: 2,
        data: ";    R  ;    R  ;     R ;     R ;      R;oo oooR;  R    ;  R    ; R     ; R     ;R      ;R ooooo;",
      },
      {
        tags: [Tag.miniJack],
        keys: 7,
        lines: 2,
        data: ";    RR ;o ooRRo; R     ;oRooo o;     R ;     R ;     R ;o ooo o; R     ; R     ; R     ;o ooooo;",
      },
      {
        tags: [Tag.miniJack],
        keys: 4,
        lines: 2,
        data: ";Rooo;R   ; ooR;   R;oRo ; R  ;o Ro;  R ;oo o;",
      },
      {
        tags: [Tag.miniJack],
        keys: 4,
        lines: 2,
        data: ";R oo;RR  ; RR ;  RR;oo R;  RR; RR ;RR  ;R oo;",
      },
      {
        tags: [Tag.chordJack],
        keys: 7,
        lines: 2,
        data: ";  R G B;  R G B;  R G B; o     ;R  GB  ;R  GB  ;R  GB  ;",
      },
      {
        tags: [Tag.chordJack],
        keys: 7,
        lines: 2,
        data: ";oo  oo ;   oo o;  oo o ; oo o  ;o oo  o; o oo  ;  o oo ;   o oo;ooo o o;",
      },
      {
        tags: [Tag.chordStream],
        keys: 7,
        lines: 2,
        data: ";RR  R R;   o   ;  o o  ; o     ;R   RRR;   o   ; o   o ;  o    ;R  R RR;    o  ; o o   ;  o    ;RR R RR;",
      },
      {
        tags: [Tag.chordStream],
        keys: 7,
        lines: 2,
        data: ";RRR  RR;   oo  ;RR   RR;  oo   ;RR  RRR;   o   ;RRR R R;   o o ;RRR R R;",
      },
      {
        tags: [Tag.jumpStream],
        keys: 4,
        lines: 2,
        data: "; o  ;R R ;   o;R R ; R R;R R ; o  ;  RR; o  ;R  R;  o ;RR  ;",
      },
      {
        tags: [Tag.jumpStream],
        keys: 4,
        lines: 2,
        data: ";  RR;o   ; o  ;  o ;R  R; o  ;  o ; o  ;R  R;",
      },
      {
        tags: [Tag.handStream],
        keys: 4,
        lines: 2,
        data: "; o  ;R RR; o  ;o o ;   o;RRR ;   o; oo ;o   ;  oo; o  ;R RR;",
      },
      {
        tags: [Tag.handStream],
        keys: 4,
        lines: 2,
        data: ";RRR ;   o;oo  ;  oo;oo  ;   o;RRR ;   o;RRR ;",
      },
      {
        tags: [Tag.quadStream],
        keys: 4,
        lines: 2,
        data: ";RRRR; o  ;o o ;   o;RRRR; o  ;o oo; o  ;RRRR;  o ;o  o; o  ;RRRR;",
      },
      {
        tags: [Tag.quadStream],
        keys: 4,
        lines: 2,
        data: ";RRRR;   o;o   ;   o;RRRR; o  ;  o ; o  ;RRRR;",
      },
      {
        tags: [Tag.jumpTrill],
        keys: 4,
        lines: 2,
        data: ";oo  ;  oo;oo  ;  oo;oo  ;  oo;oo  ;  oo;",
      },
      {
        tags: [Tag.jumpTrill],
        keys: 4,
        lines: 2,
        data: ";  oo;oo  ;  oo;oo  ;  oo;oo  ;  oo;oo  ;",
      },
      {
        tags: [Tag.pJumpTrill],
        keys: 4,
        lines: 4,
        data: ";   o;  o ; o  ;o   ;   o;  o ; o  ;o   ;   o;  o ; o  ;o   ;   o;  o ; o  ;o   ;   o;  o ; o  ;o   ;   o;  o ; o  ;o   ;   o;  o ; o  ;o   ;",
      },
      {
        tags: [Tag.pJumpTrill],
        keys: 4,
        lines: 4,
        data: ";   o;  o ; o  ;o   ;  o ;   o;o   ; o  ;   o;  o ;o   ; o  ;  o ;   o; o  ;o   ;  o;   o; o  ;o   ;   o;  o ;o  ; o  ;  o;   o; o  ;o   ;",
      },
      {
        tags: [Tag.splitTrill],
        keys: 4,
        lines: 2,
        data: ";o o ; o o;o o ; o o;o o ; o o;o o ; o o;",
      },
      {
        tags: [Tag.splitTrill],
        keys: 4,
        lines: 2,
        data: ";o  o; oo ;o  o; oo ;o  o; oo ;o  o; oo ;",
      },
      {
        tags: [Tag.roll],
        keys: 4,
        lines: 2,
        data: ";o   ;   o; o  ;  o ;o   ; o  ;   o;o   ;  o ; o  ;   o;  o ;o   ;   o; o  ;o   ;  o ;   o; o  ;  o ;   o;",
      },
      {
        tags: [Tag.roll],
        keys: 4,
        lines: 2,
        data: ";  o ; o  ;o   ;  oo;o   ; o  ;  o ;o   ;   o; o  ;  o ;o  o;  o ; o  ;   o;o   ;  o ; o  ;o  o;",
      },
      {
        tags: [Tag.roll],
        keys: 4,
        lines: 2,
        data: ";oo o;  o ; o  ;o o ;   o; o  ;  o ;o  o; o  ;  o ;o   ; o o;  o ; o  ;o  o;  o ; o  ;o oo;",
      },
      {
        tags: [Tag.gallop],
        keys: 4,
        lines: 2,
        data: ";o oo; o  ;  X ; o  ;o  o;  o ; X  ;  o ;oo o;",
      },
      {
        tags: [Tag.gallop],
        keys: 4,
        lines: 2,
        data: ";o oo; o  ;  o ;   o; X  ;   o;  o ; o  ;o  o;  o ; o  ;o   ;  X ;o   ; o  ;  o ;oo o;",
      },
      {
        tags: [
          /*tag.23*/
        ],
        keys: 4,
        lines: 2,
        data: ";R R ; R R;R R ; o  ;  RR;RR  ;  RR; o  ;R  R; RR ;R  R;",
      },
      {
        tags: [
          /*tag.23*/
        ],
        keys: 4,
        lines: 2,
        data: "; RR ;R  R; RR;o   ; R R;R R ; R R;  o;R  R; RR ;R  R;",
      },
      {
        tags: [
          /*tag.24*/
        ],
        keys: 4,
        lines: 2,
        data: ";   R;  R ; R  ;R   ;  G ;   G;G   ; G  ;   R;  R ; R  ;R   ;",
      },
      {
        tags: [
          /*tag.24*/
        ],
        keys: 4,
        lines: 2,
        data: ";R   ; R  ;  R ;   R; G  ;G   ;   G;  G ;R   ; R  ;  R ;   R;",
      },
      {
        tags: [
          /*tag.25*/
        ],
        keys: 4,
        lines: 2,
        data: "; o  ;o   ;  o ;   o; o  ;  o ;   o; o  ;o   ;  o ; o  ;o   ;",
      },
      {
        tags: [
          /*tag.25*/
        ],
        keys: 4,
        lines: 2,
        data: ";o   ; o  ;   o;  o ; o  ;   o;  o ;o   ; o  ;  o ;o   ; o  ;",
      },
      {
        tags: [
          /*tag.26*/
        ],
        keys: 4,
        lines: 2,
        data: ";||R ;|| R;||R ;|| R;||R ;|| R;||R ;|^  ;^  o;  o ; o  ;o   ;",
      },
      {
        tags: [
          /*tag.26*/
        ],
        keys: 4,
        lines: 2,
        data: ";oo  ;   R;-   ;   R;-   ;   R;-   ;   R;  R ; o o;o o ;",
      },
      {
        tags: [
          /*tag.27*/
        ],
        keys: 4,
        lines: 2,
        data: ";o   ;^   ;  o ;  ^ ; o  ; ^  ;  o ;  ^ ;   o;   ^;",
      },
      {
        tags: [
          /*tag.27*/
        ],
        keys: 4,
        lines: 2,
        data: ";oooo;^^^^;oooo;||||;||||;||||;||||;||||;||||;||||;||||;^^^^;",
      },
      {
        tags: [
          /*tag.28*/
        ],
        keys: 7,
        lines: 2,
        data: "; |o  | ;o|   | ; |  o| ; |   |o; |  o| ; |   |o; |o  | ;o|   | ; |o  | ;o|   | ; |  o| ; |   |o; |  o| ; ^   ^o;",
      },
      {
        tags: [
          /*tag.28*/
        ],
        keys: 7,
        lines: 2,
        data: ";| | |o|;| |o| |;|o| | |;| | |o|;| |o| |;|o| | |;| |o| |;| | |o|;|o| | |;| |o| |;| | |o|;| |o| |;|o| | |;^ ^ ^ ^;",
      },
      {
        tags: [
          /*tag.29*/
        ],
        keys: 7,
        lines: 2,
        data: ";oo o oo;  o o  ; o   o ;   o   ;ooo ooo;   o   ;  o o  ; o   o ;o ooo o;",
      },
      {
        tags: [
          /*tag.29*/
        ],
        keys: 7,
        lines: 2,
        data: "; B  B  ;  B  B ; B  B  ;B  B  o;  G  G ; G  G  ;  G  G ;o  G  G; R  R  ;  R  R ; R  R  ;R oR oo;",
      },
      {
        tags: [
          /*tag.30*/
        ],
        keys: 7,
        lines: 2,
        data: ";  o   o; o   o ;o  oo  ;  B  BB;BB B BB;  G    ;   G GG;GG  G  ;GG G GG;  R    ;   R RR;RR  R  ;RR R RR;",
      },
      {
        tags: [
          /*tag.30*/
        ],
        keys: 7,
        lines: 2,
        data: ";  BB   ; B  B  ;B B    ;B B  BB;   GG  ;  G  G ;    G G;GG  G G;  RR   ; R  R  ;R R    ;R R  RR;",
      },
      {
        tags: [
          /*tag.31*/
        ],
        keys: 7,
        lines: 2,
        data: ";RR o BB;XXX B  ; R o B ;  R XXX;RR  B B;XXXo B ; R  B B;  R XXX;RR oB B;XXX  B ;R R B  ; R  XXX;R Ro BB;",
      },
      {
        tags: [
          /*tag.31*/
        ],
        keys: 7,
        lines: 2,
        data: ";RR oB B;  R XXX;RR o BB;  R XXX;RRRo BB;XXX B  ;RR o BB;XXX B  ;RR oBBB;",
      },
      {
        tags: [
          /*tag.32*/
        ],
        keys: 4,
        lines: 2,
        data: ";  RR;B   ;  R ;BB  ;   R; B  ;  RR;B   ;  R ;BB  ;   R; B  ;  RR;",
      },
      {
        tags: [
          /*tag.32*/
        ],
        keys: 4,
        lines: 2,
        data: ";  RR; B  ;  R ; B  ;  RR;B   ;   R;B   ;  RR; B  ;  R ; B  ;  RR;",
      },
      {
        tags: [
          /*tag.33*/
        ],
        keys: 7,
        lines: 2,
        data: ";     RR; GG    ; GG    ;    RR ;GG     ;     RR;G G    ;    R R;    R R; GG    ;    RR ;    RR ;oo o  o;",
      },
      {
        tags: [
          /*tag.33*/
        ],
        keys: 7,
        lines: 2,
        data: "; GG  RR;    R  ;     RR; GG    ; GG  RR;    R  ; GG  RR;    R  ;     RR; GG    ; GG  RR;    R  ;oGGo RR;",
      },
      {
        tags: [
          /*tag.34*/
        ],
        keys: 4,
        lines: 2,
        data: ";R   ; o  ;R o ; o o;R o ;R  o; o  ;R o ; o o;R o ;R  o; o  ;R  o;",
      },
      {
        tags: [
          /*tag.34*/
        ],
        keys: 4,
        lines: 2,
        data: ";  oo; o||;o ||;  ^^;o oo;  ^^;o oo; o||;o ^^;",
      },
      {
        tags: [
          /*tag.35*/
        ],
        keys: 7,
        lines: 2,
        data: ";   o   ;  o    ; o     ;o      ;  o    ; o     ;   o   ;  o    ;    o  ;   o   ;     o ;    o  ;      o;",
      },
      {
        tags: [
          /*tag.35*/
        ],
        keys: 7,
        lines: 2,
        data: ";  o    ; o     ;o  o   ;  o    ; o  o  ;   o   ;  o  o ;    o  ;   o  o;     o ;    o  ;      o;     o ;",
      },
      {
        tags: [
          /*tag.35*/
        ],
        keys: 7,
        lines: 2,
        data: ";o      ; o     ;  o    ;   o   ; o     ;  o    ;   o   ;    o  ;  o    ;   o   ;    o  ;     o ;   o   ;    o  ;     o ;      o;",
      },
      {
        tags: [
          /*tag.36*/
        ],
        keys: 7,
        lines: 2,
        data: ";  B  G ; B  G  ;B  G  R;  G  R ; G  R  ;  G  R ;B  G  R; B  G  ;  B   R; B   R ;B   R  ;     R ;      R;",
      },
      {
        tags: [
          /*tag.36*/
        ],
        keys: 7,
        lines: 2,
        data: ";B      ; B     ;B     G;     G ; R    G;  R    ; R   B ;    B  ;G    B ; G     ;G     R;     R ;      R;",
      },
      {
        tags: [
          /*tag.37*/
        ],
        keys: 7,
        lines: 2,
        data: ";      R;     R ;    R  ;      B;   R   ;     B ;  R    ;    B  ; R     ;   B   ;R      ;  B    ;   B   ;B   B  ; B   B ;  B   B;R      ;   B   ; R     ;    B  ;  R    ;     B ;   R   ;      B;",
      },
      {
        tags: [
          /*tag.37*/
        ],
        keys: 7,
        lines: 2,
        data: ";  B    ;    G  ;      R; B     ;   G   ;     R ;B      ;  G    ;    R  ; B     ;   G   ;     R ;  B    ;    G  ;      R;",
      },
    ],
    patternMetas: {
      stair: {
        title: "Stairs",
        body: "They look like staircases.",
        complexity: 0,
      },
      trill: {
        title: "Trills",
        body: "Repeating <code>ABAB...</code> pattern",
        complexity: 0,
      },
      chord: {
        title: "Chords",
        body: "Many notes played at the same time.",
        complexity: 0,
      },
      grace: {
        title: "Graces",
        body: "Very fast, short stairs. Usually connected.",
        complexity: 0,
      },
      burst: {
        title: "Bursts",
        body: "Short, Dense Patterns",
        complexity: 0,
      },
      bracket: {
        title: "Brackets",
        body: "If it forms a <i class='bi bi-chevron-up'></i> or <i class='bi bi-chevron-down'></i> &times or any combination, it's a bracket.",
        complexity: 0,
      },
      jack: {
        title: "Jacks",
        body: "Repeated Notes on the same column.",
        complexity: 0,
      },
      ln: {
        title: "Long Note Patterns",
        body: "Patterns involving <b>mostly</b> holds",
        complexity: 0,
      },
      shield: {
        title: "Shields",
        body: "An LN right after a note",
        complexity: 1,
      },
      invShield: {
        title: "Inverted Shields",
        body: "A Note right after an LN End",
        complexity: 1,
      },
      inv: {
        title: "Inverse / Full LN",
        body: "Fully covered with Long Notes",
        complexity: 1,
      },
      anchor: {
        title: "Anchors",
        body: "<b>The Jacking Column</b> during any pattern.",
        complexity: 1,
      },
      miniJack: {
        title: "Mini-Jacks",
        body: "Jacks but short. Commonly only 2 or 3 repetitions.",
        complexity: 1,
      },
      chordJack: {
        title: "Chord Jacks",
        body: "Chords that happen to Jack",
        complexity: 1,
      },
      chordStream: {
        title: "Chord Streams",
        body: "Chords, with streams in between",
        complexity: 1,
      },
      jumpStream: {
        title: "Jump Streams",
        body: "2 Note-Chords, with streams in between. Common in 4 Keys",
        complexity: 1,
      },
      handStream: {
        title: "Hand Streams",
        body: "3 Note-Chords, with streams in between. Common in 4 Keys",
        complexity: 1,
      },
      quadStream: {
        title: "Quad Streams",
        body: "4 Note-Chords, with streams in between.",
        complexity: 1,
      },
      jumpTrill: {
        title: "Jump Trills",
        body: "2 Note-Chords that trill.",
        complexity: 1,
      },
      pJumpTrill: {
        title: "Pseudo Jump Trills",
        body: "Jump Trills that are manipulatable.",
        complexity: 1,
      },
      splitTrill: {
        title: "Split Trills",
        body: "2 Note-Chords that requires 1-hand trills.",
        complexity: 1,
      },
      roll: {
        title: "Rolls",
        body: "Very Fast Stairs",
        complexity: 1,
      },
      gallop: {
        title: "Gallop / Swing",
        body: "Certain beats are omitted to emphasize specific rhythms",
        complexity: 1,
      },
    },
  },
  mutations: {},
  actions: {},
  modules: {},
  getters: {
    tagTitles(state: State) {},
  },
});
export type { Pattern };
export default rgStore;
